import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { browserLanguage, convertToBoolean, isTypeof } from './../../utils/util';
import { ThfSelectOption } from '@totvs/thf-ui';

@Component({
  selector: 'thf-page-background',
  templateUrl: './thf-page-background.component.html'
})

/**
 * @docsPrivate
 *
 * @description
 *
 * Componente para definiÃ§Ã£o de cor de fundo e dos logotipos primÃ¡rio e secundÃ¡rio para os templates
 * de `thf-page-login` e demais templates de login.
 */
export class ThfPageBackgroundComponent implements OnInit {

  private _logo?: string;
  private _secondaryLogo?: string;
  private _showSelectLanguage?: boolean = false;

  selectedLanguageOption: string;

  selectLanguageOptions: Array<ThfSelectOption> = [
    { label: 'English', value: 'en' },
    { label: 'EspaÃ±ol', value: 'es' },
    { label: 'PortuguÃªs', value: 'pt' }
  ];

  /** Insere uma imagem de destaque ao lado direito do container. */
  @Input('t-background') background?: string;

  /** Designa se o logotipo deve desaparecer em resoluÃ§Ãµes menores. */
  @Input('t-hide-logo') hideLogo?: boolean;

  /** Texto de destaque sobreposto Ã  imagem de destaque. Essa opÃ§Ã£o Ã© utilizada em conjunto com o atributo `t-background`. */
  @Input('t-highlight-info') highlightInfo?: string;

  /** Caminho para a logomarca localizada na parte superior. */
  @Input('t-logo') set logo(value: any) {
    this._logo = isTypeof(value, 'string') && value.trim() ? value : undefined;
  }

  get logo() {
    return this._logo;
  }

  /**
   * @optional
   *
   * @description
   *
   * Caminho para a logomarca localizada no rodapÃ©.
   */
  @Input('t-secondary-logo') set secondaryLogo(value: any) {
    this._secondaryLogo = isTypeof(value, 'string') && value.trim() ? value : undefined;
  }

  get secondaryLogo() {
    return this._secondaryLogo;
  }

  /** Define se o seletor de idiomas deve ser exibido. */
  @Input('t-show-select-language') set showSelectLanguage(showSelectLanguage: boolean) {
    this._showSelectLanguage = convertToBoolean(showSelectLanguage);
  }
  get showSelectLanguage() {
    return this._showSelectLanguage;
  }

  /**
   * Evento disparado ao selecionar alguma opÃ§Ã£o no seletor de idiomas.
   * Para este evento serÃ¡ passado como parÃ¢metro o valor de idioma selecionado.
   */
  @Output('t-selected-language') selectedLanguage?: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.selectedLanguageOption = browserLanguage();
  }

  onChangeLanguage() {
    this.selectedLanguage.emit(this.selectedLanguageOption);
  }

}
